import React from 'react';
import { useAuth } from '../context/AuthContext'
import { Link } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Autocomplete,
  TextField,
  Box
 } from '@mui/material';
import { Logout, Fitbit } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import API from '../services/api';
import { useState, useEffect } from 'react';
import { useDatabases } from '../context/DatabaseContext';

const NavBar = ({ onDatabaseChange }) => {
  const { isAuthenticated, user, role, logout } = useAuth();

  const { databases, refreshDatabases } = useDatabases();
  const [selectedDatabase, setSelectedDatabase] = useState({id: 'empty', name: ''});

  useEffect(() => {
    if (role === 'administrator') {
      refreshDatabases();
    }
  }, [role]);

  useEffect(() => {
    if (role === 'administrator') {
      API.get('/api/adminSettings/selectedDatabase')
          .then(response => setSelectedDatabase(response.data))
          .catch(error => console.error('Error loading selectedDatabase:', error));
    }
  }, [role, databases]);

  const handleDatabaseSelection = (newDatabase) => {
    if (newDatabase) {
      API.post('/api/adminSettings/selectedDatabase', { databaseId: newDatabase.id})
          .then(response => {
            setSelectedDatabase(response.data);
            onDatabaseChange(response.data);
          })
          .catch(error => console.error('Error setting selectedDatabase:', error));
    }
  };

  const location = useLocation();
  const currentPath = location.pathname;

  // Buttons attached to roles
  const buttonsConfig = [
    { path: '/home', label: 'Home', roles: ['manager', 'administrator'] },
    { path: '/customers', label: 'Customers', roles: ['manager', 'administrator'] },
    { path: '/qrpasses', label: 'QR Passes', roles: ['manager', 'administrator'] },
    { path: '/display', label: 'Display', roles: ['display', 'manager', 'administrator'] },
    { path: '/maintenance', label: 'Maintenance', roles: ['administrator'] },
  ];

  const visibleButtons = buttonsConfig.filter(button => 
    button.roles.includes(role)
  );

  // No menu in this case
  if (!isAuthenticated || role === 'display') {
    return null;
  }

  const handleLogoutClick = async () => {
     try {
          const res = await API.post('/api/auth/logout');
          logout();
        } catch (err) {
          console.error('Logout error: ', err);
        }
  };

  return (
    <AppBar position="static">
      <Toolbar>
          <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              flexGrow: 1,
              justifyContent: 'flex-start'
            }}>
              <Fitbit/>
              <Typography>
                  Database:
              </Typography>
              {role === 'administrator' ? (
              <Autocomplete
                options={databases}
                getOptionValue={(db) => db.id}
                getOptionLabel={(db) => db.name}
                value={selectedDatabase}
                onChange={(e, newValue) => handleDatabaseSelection(newValue)}
                size="small"
                disableClearable 
                required
                sx={{
                  width: '200px',
                  border: 'none',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                  borderRadius: '8px',
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      display: 'none',
                    },
                    '&:hover fieldset': {
                      display: 'none',
                    },
                    '&.Mui-focused fieldset': {
                      display: 'none',
                    },
                    '& .MuiAutocomplete-clearIndicator': {
                      color: 'white',
                    },
                    '& .MuiAutocomplete-popupIndicator': {
                      color: 'white', // Arrow color
                    }
                  },
                  '& input': {
                    color: 'white', // Text color
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{
                      '& .MuiOutlinedInput-input': {
                        color: 'white', // Input text color
                      },
                    }}
                    label=""
                  />
                )} />
              ) : role === 'manager' ? (
              <Typography sx={{ flexGrow: 1 }}>
              
                  <span sx={{ marginRight: '16px' }}> {user.database.name}</span>
              </Typography> 
              ) : null }
          </Box>
        {visibleButtons.map(({ path, label }) => (
          <Button
            key={path}
            component={Link}
            to={path}
            variant="contained"
            color="primary"
            sx={{
              marginRight: '16px',
              backgroundColor: currentPath.startsWith(path) ? '#FF6347' : 'initial'
             }}
          >
            {label}
          </Button>
        ))}

        {/* Logout button */}
        <Button
          variant="contained"
          color="primary"
          sx={{ marginLeft: '16px' }}
          onClick={() => handleLogoutClick()}
        >
          <Logout />
        </Button>

      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
